import { render, staticRenderFns } from "./tenantauth-info.vue?vue&type=template&id=0cec3114&"
import script from "./tenantauth-info.vue?vue&type=script&lang=js&"
export * from "./tenantauth-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tenantauth-info.vue"
export default component.exports